export type Incident = {
  id: string;
  reported_at: string;
  occurred_at: string | null;
  location_name: string;
  country_code: string | null;
  lat: number;
  lon: number;
  case_type: "detected" | "deceased";
  case_count: number;
  strain: string | null;
  strain_nl: string | null;
  location_name_nl: string | null;
  vessel_name_nl: string | null;
  vector: "cruise_ship" | "plane" | null;
  flight_type: "passenger" | "medevac" | null;
  vessel_name: string | null;
  trajectory: string | null;          // JSON-encoded [lon, lat][] when present
  route_log: string | null;           // JSON-encoded RouteWaypoint[] when present
  persons: string | null;             // JSON-encoded Person[] when present
  countries_visited: string | null;   // JSON-encoded { code, label_en, label_nl }[]
  summary_en: string;
  summary_nl: string;
  first_seen: string;
  last_seen: string;
  sources: Array<{ url: string; publisher: string; title: string | null }>;
};

export type DateRow = { date: string; count: number };

const BASE = "/api";

export async function fetchIncidents(date?: string): Promise<Incident[]> {
  const url = new URL(BASE + "/incidents", window.location.origin);
  if (date) url.searchParams.set("date", date);
  const r = await fetch(url.toString());
  if (!r.ok) throw new Error(`incidents fetch failed: ${r.status}`);
  const j = (await r.json()) as { incidents: Incident[] };
  return j.incidents;
}

export async function fetchDates(): Promise<DateRow[]> {
  const r = await fetch(BASE + "/dates");
  if (!r.ok) throw new Error(`dates fetch failed: ${r.status}`);
  const j = (await r.json()) as { dates: DateRow[] };
  return j.dates;
}

export async function fetchHealth(): Promise<{ ok: boolean; ts: string }> {
  const r = await fetch(BASE + "/healthz");
  return (await r.json()) as { ok: boolean; ts: string };
}
